import { Citation, ResourceCard } from './../../models/support.models';
import { VideoLinks } from './../../models/support.models';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-chat-resource-cards',
  templateUrl: './chat-resource-cards.component.html',
  styleUrl: './chat-resource-cards.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class ChatResourceCardsComponent implements OnInit {

  @Input() videos: VideoLinks[];
  @Input() citations: Citation[];
  @Input() isMobileApp: boolean = false;
  @Input() isCCU: boolean = false;
  defaultThumbnailPath: string = '';
  @Output() mobileCitationLinkClicked = new EventEmitter<{ from: string, url: string }>();

  resourceCards: ResourceCard[] = [];

  ngOnInit(): void {
    this.resourceCards = [
      // Map videos to resource cards, using the video link as the URL and extracting the host for display.
      ...this.videos.map(video => ({
        type: 'video' as const,
        title: video.title,
        link: video.link,
        thumbnailUrl: video.thumbnailUrl,
        host: video.source ? this.getHost(video.source) : ''
      })),

      // Map citations to resource cards, using the source as the link and extracting the host for display.
      ...this.citations.map(citation => ({
        type: 'citation' as const,
        title: citation.title,
        link: citation.source,
        thumbnailUrl: citation.imageUrl,
        host: citation.source ? this.getHost(citation.source) : ''
      })),
    ];
    this.defaultThumbnailPath = 'assets/images/chatbot-default-thumbnail.jpg';
  }

  // Opens the citation or video link in a new tab or emits an event for mobile apps to open in in-app browsers.
  openLink(url: string): void {
    if (this.isMobileApp || this.isCCU) {
      this.mobileCitationLinkClicked.emit({ from: 'article_resource', url });
    } else {
      window.open(url, '_blank');
    }
  }

  // Utility function to extract hostname from a URL for display purposes.
  getHost(url: string): string {
    try {
      return new URL(url).hostname;
    } catch {
      return url;
    }
  }
}
